<script>
export default {
    beforeMount(){
        swal("결제가 완료되었습니다. \n인스타그램 쇼핑태그 샵승인 신청서를 작성해주세요.", {
            icon: "success",
        }).then(() => {
            this.$router.push('/main/insta?tab=apply&scroll=800')
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pay/InstaSuccess.vue